import './App.css';

import {
  Switch,
  Route,
  Redirect
} from "react-router-dom";

import Shares from './views/Shares';
import Tasks from './views/Tasks';
import Management from './views/Management';
import Settings from './views/Settings';
import User from './views/User';
import Homepage from './views/Homepage';
import NotFound from './views/NotFound';

import GeneralLayout from './layouts/GeneralLayout';
import RepoLayout from './layouts/RepoLayout';


function App() {

  return (
    <div className="App">

      <Switch>
          <Route exact path={`/`}>
            <GeneralLayout><Homepage/></GeneralLayout>
          </Route>
          <Route exact path={`/:userName/`}>
            <GeneralLayout><User/></GeneralLayout>
          </Route>

          <Redirect exact from="/:userName/:repoName" to="/:userName/:repoName/shares" />

          <Route exact path={`/:userName/:repoName/shares`}>
            <RepoLayout><Shares/></RepoLayout>
          </Route>
          <Route exact path={`/:userName/:repoName/tasks`}>
            <RepoLayout><Tasks /></RepoLayout>
          </Route>
          <Route exact path={`/:userName/:repoName/management`}>
            <RepoLayout><Management /></RepoLayout>
          </Route>
          <Route exact path={`/:userName/:repoName/settings`}>
            <RepoLayout><Settings /></RepoLayout>
          </Route>

          <Route>
            <GeneralLayout><NotFound/></GeneralLayout>
          </Route>
      </Switch>

    </div>
  );
}

export default App;
